import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './store/reduxStore';
import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import { LicenseInfo } from '@mui/x-license';
import CacheBuster from 'react-cache-buster'; 
import packageInfo from '../package.json';

const licenseKey = process.env.REACT_APP_MUI_LICENSE_KEY;
if (licenseKey) {
  LicenseInfo.setLicenseKey(licenseKey);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CacheBuster 
       currentVersion={packageInfo.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<div className={'text-center mt-3'}>Loading Please Wait....</div>} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
    <Provider store={store}>
      <App />
    </Provider>
    </CacheBuster>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
